var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Snackbar, Button, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '../../assets/closeDesktop.svg';
import ShareIcon from '../../assets/box-arrow-left.svg';
import styles from '../HomePage/HomePage.module.scss';
import { useTypedTranslation } from '../../hooks/useTypedTranslation';
export const PWAInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showAndroidPrompt, setShowAndroidPrompt] = useState(false);
    const [showIOSPrompt, setShowIOSPrompt] = useState(false);
    const { t } = useTypedTranslation();
    useEffect(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;
        if (isStandalone)
            return;
        //chrome
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowAndroidPrompt(true);
        };
        //iOS (Safari)
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS && !isStandalone) {
            const timer = setTimeout(() => setShowIOSPrompt(true), 5000);
            return () => clearTimeout(timer);
        }
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', () => {
            setShowAndroidPrompt(false);
            setDeferredPrompt(null);
        });
        return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }, []);
    const handleInstallClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!deferredPrompt)
            return;
        deferredPrompt.prompt();
        const { outcome } = yield deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setDeferredPrompt(null);
            setShowAndroidPrompt(false);
        }
    });
    const handleClose = () => {
        setShowAndroidPrompt(false);
        setShowIOSPrompt(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Snackbar, { open: showAndroidPrompt, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, onClose: handleClose, message: t('pwa.message'), action: _jsxs(_Fragment, { children: [_jsx(Button, { sx: { color: '#8774e1' }, size: "small", onClick: handleInstallClick, children: t('pwa.install') }), _jsx(IconButton, { size: "small", color: "inherit", onClick: handleClose, children: _jsx(CloseIcon, { fontSize: "small" }) })] }) }), _jsx(Snackbar, { open: showIOSPrompt, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, onClose: handleClose, children: _jsxs(Box, { sx: {
                        bgcolor: '#313131',
                        color: '#eeebeb',
                        p: 2,
                        borderRadius: 1,
                        boxShadow: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1
                    }, children: [_jsxs(Typography, { variant: "body2", textAlign: "center", children: [t('pwa.iosMessage1'), _jsx("div", { className: styles.shareChatButton__icon, children: _jsx(ShareIcon, {}) }), t('pwa.iosMessage2'), " ", _jsx("b", { children: t('pwa.iosMessage3') })] }), _jsx(Button, { size: "small", onClick: handleClose, children: "OK" })] }) })] }));
};
